import { get } from '@/services/API';

export default {
  getSearch: (searchValue, params) => get(`/api/search/${searchValue}?${new URLSearchParams(params)}`),
};
